export const isEmpty = (obj) => Object.keys(obj).length === 0;

// This function will convert an array of the form
// ["a", "b", "c", ...] to {"a": "a", "b": "b", "c": "c"}
export const arrayToMapObject = (arr: string[]) => arr.reduce((a, v) => ({ ...a, [v]: v }), {});
